<template>
  <div>
    <the-headersider></the-headersider>
    <div class="container-fluid">

  
   <div class="fw-b fs-3">
    Dashboard

   </div>
    <div class="row">
      <div class="col-md-2">
        <div class="card text-dark bg-light h-100">
          <div class="card-header">Clients</div>
          <div class="card-body">
            <h5 class="card-title">Total clients</h5>
            <small>
              <p class="card-text">{{ clients.length }} clients registered.</p>
            </small>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card text-dark bg-light h-100">
          <div class="card-header">Courts</div>
          <div class="card-body">
            <h5 class="card-title">Total courts</h5>
            <small>
              <p class="card-text">{{ courts.length }} courts served.</p>
            </small>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card text-dark bg-light h-100">
          <div class="card-header">Amount</div>
          <div class="card-body">
            <h5 class="card-title">Total collected</h5>
            <small>
              <p class="card-text">{{ total_collected  }} Khs collected and allocated.</p>
            </small>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card text-dark bg-light h-100">
          <div class="card-header">Mpesa</div>
          <div class="card-body">
            <h5 class="card-title">Unalllocated</h5>
            <small>
              <p class="card-text">{{ unAllocatedMpesa }} Kshs collected but not allocated to clients.</p>
            </small>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card text-dark bg-light h-100">
          <div class="card-header">Arrears</div>
          <div class="card-body">
            <h5 class="card-title">Uncollected</h5>
            <small>
              <p class="card-text">{{ total_arrears }} Kshs arreas to be collected</p>
            </small>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="card text-dark bg-light h-100">
          <div class="card-header">Revenue</div>
          <div class="card-body">
            <h5 class="card-title">Montly collections</h5>
            <small>
              <p class="card-text">{{ monthly_collections }} Kshs total revenues to be collected monthly.</p>
            </small>
          </div>
        </div>
      </div>
    </div>
</div>

    
  </div>
</template>
<script>
export default {
  computed: {
    total_collected() {
      return this.payments.reduce((total, item) => {
        return total + item.amount;
      }, 0);
    },
    total_arrears() {
      return this.clients.reduce((total, item) => {
        return total + item.arrears;
      }, 0);
    },
    monthly_collections() {
      return this.clients.reduce((total, item) => {
        return total + item.montlyPayment;
      }, 0);
    },
    unAllocatedMpesa() {
      return this.unallocatedPayments.reduce((total, item) => {
        return total + Math.round(item.amount);
      }, 0);
    },

    clients() {
      return this.$store.getters.clients;
    },
    payments() {
      return this.$store.getters.payments;
    },
    unallocatedPayments() {
      return this.$store.getters.unAllocatedMpesaPayments();
    },
    courts() {
      return this.$store.getters.courts;
    },
    id_client() {
      return this.client_id + 1;
    },
  },
  created() {
    this.$store.dispatch("LoadClients");
    this.$store.dispatch("LoadCourts");
    this.$store.dispatch("LoadPayments");
    this.$store.dispatch("LoadMpesapayments");
  },
};
</script>

<style scoped>
.dashboard {
  background-color: azure;
  box-sizing: border-box;
  padding: 3px;
  display: grid;
  grid-template-rows: 1fr 4fr;
  grid-template-columns: 1fr 2fr 4fr;
  grid-gap: 0ch;
  height: 100vh;

  grid-template-areas: 
    /* "theader theader theader" */
    "sidebar sheader sheader"
    "sidebar smain smain";
}
.sidebar {
  grid-area: sidebar;
  background-color: rgb(113, 180, 47);
}
.sheader {
  grid-area: sheader;
  background-color: rgb(221, 216, 209);
}
.smain {
  grid-area: main;
  background-color: beige;
}
.theader {
  grid-area: theader;
  grid-area: theader;
}
</style>
